import { axiosInstance } from '../../utils/axios-instance'

const state = () => ({
  query: '',
  loading: false,
  slides: [],
  hasMore: true
})

const mutations = {
  setQuery (state, query) {
    state.query = query
    state.slides = []
    state.hasMore = true
  },
  resetQuery (state) {
    state.query = ''
    state.slides = []
    state.hasMore = true
  },
  resetResults (state) {
    state.slides = []
    state.hasMore = true
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  concatSlides (state, slides) {
    state.slides = state.slides.concat(slides)
  },
  setHasMore (state, hasMore) {
    state.hasMore = hasMore
  }
}

const actions = {
  // eslint-disable-next-line camelcase
  async fetchSearchResults ({ rootState, commit, state }, { page, page_size }) {
    if (state.query === '') {
      return []
    }
    commit('setLoading', true)
    const response = await axiosInstance(
      '/search/',
      { params: { page, page_size, search: state.query, ordering: rootState.filtering.ordering } }
    )
    commit('concatSlides', response.data.results)
    commit('setHasMore', response.data.next !== null)
    return response.data.results
  }
}

export default {
  namespaced: true, state, mutations, actions
}
